var _ellipse, _ellipse2, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _ellipse3, _circle4, _circle5, _path, _circle6, _circle7, _circle8, _path2, _circle9, _rect4, _path3, _path4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 269,
    viewBox: "0 0 149 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 143.5,
    rx: 51,
    ry: 36.5,
    fill: "#FFCD03"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 81.5,
    rx: 51,
    ry: 36.5,
    fill: "#FFCD03"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 225,
    width: 148,
    height: 42,
    fill: "#E95DA2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 229,
    width: 149,
    height: 40,
    fill: "#E95DA2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 44,
    width: 102,
    height: 39,
    fill: "#FFCD03"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 44.5,
    r: 25.5,
    fill: "#FFCD03"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 227.5,
    r: 25.5,
    fill: "#E95DA2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 44.5,
    r: 25.5,
    fill: "#FFCD03"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.5,
    cy: 227,
    rx: 25.5,
    ry: 25,
    fill: "#E95DA2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 52,
    r: 11.5,
    fill: "white",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 9,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2666 57.8022C54.409 58.31 54.1127 58.8435 53.591 58.9202C52.4481 59.0883 51.2773 58.9906 50.1711 58.6292C48.761 58.1686 47.5192 57.3002 46.6028 56.1339C45.6863 54.9675 45.1362 53.5555 45.0222 52.0766C44.9327 50.9163 45.1148 49.7556 45.5484 48.6849C45.7463 48.1961 46.3348 48.0344 46.7945 48.2929C47.2542 48.5513 47.4087 49.132 47.2322 49.629C46.9715 50.3628 46.8659 51.1464 46.9263 51.9298C47.0113 53.0321 47.4213 54.0845 48.1044 54.9539C48.7875 55.8233 49.7131 56.4706 50.7641 56.8139C51.511 57.0579 52.2973 57.1406 53.0719 57.0609C53.5965 57.007 54.1243 57.2944 54.2666 57.8022Z",
    fill: "#00BED3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 50,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "matrix(-1 0 0 1 111 40)",
    fill: "white",
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "matrix(-1 0 0 1 105 43)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7334 57.8022C93.591 58.31 93.8873 58.8435 94.409 58.9202C95.5519 59.0883 96.7227 58.9906 97.8289 58.6292C99.239 58.1686 100.481 57.3002 101.397 56.1339C102.314 54.9675 102.864 53.5555 102.978 52.0766C103.067 50.9163 102.885 49.7556 102.452 48.6849C102.254 48.1961 101.665 48.0344 101.206 48.2929C100.746 48.5513 100.591 49.132 100.768 49.629C101.028 50.3628 101.134 51.1464 101.074 51.9298C100.989 53.0321 100.579 54.0845 99.8956 54.9539C99.2125 55.8233 98.2869 56.4706 97.2359 56.8139C96.489 57.0579 95.7027 57.1406 94.9281 57.0609C94.4035 57.007 93.8757 57.2944 93.7334 57.8022Z",
    fill: "#00BED3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 94 48)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 202,
    width: 97,
    height: 24,
    fill: "#E95DA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 143.5C125 133.82 119.627 124.536 110.062 117.691C100.498 110.846 87.526 107 74 107C60.474 107 47.5019 110.846 37.9376 117.691C28.3732 124.536 23 133.82 23 143.5L74 143.5H125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 202.5C125 192.82 119.627 183.536 110.062 176.691C100.498 169.846 87.526 166 74 166C60.474 166 47.5019 169.846 37.9376 176.691C28.3732 183.536 23 192.82 23 202.5L74 202.5H125Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 101,
    width: 53,
    height: 11,
    fill: "#FFCD03"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 163,
    width: 60,
    height: 10,
    fill: "#FFCD03"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeLogo);
export default __webpack_public_path__ + "static/media/bee-logo.4be5d41688156593de75f2c1dec81aa5.svg";
export { ForwardRef as ReactComponent };